import React from 'react';
import './style.css';

// Helper: map card code to image
const getCardImage = (cardString) => {
  if (!cardString) return null;
  return `/assets/img/cards/${cardString}.png`;
};

// Helper: split cards into Player A / Player B (indexes 0,2,4 vs 1,3,5)
const parseCards = (cardString) => {
  if (!cardString) return { playerA: [], playerB: [] };

  const cards = cardString.split(',');
  const playerACards = [0, 2, 4].map(i => {
    const card = cards[i]?.trim();
    return card ? getCardImage(card) : null;
  }).filter(Boolean);

  const playerBCards = [1, 3, 5].map(i => {
    const card = cards[i]?.trim();
    return card ? getCardImage(card) : null;
  }).filter(Boolean);

  return { playerA: playerACards, playerB: playerBCards };
};

// Helper: parse rdesc (Winner#Suits#Odd/Even#Consecutive)
const parseRdesc = (rdesc) => {
  if (!rdesc) return {};

  const parts = rdesc.split('#');
  const winner = parts[0] || "";
  const suits = parts[1] || "";
  const oddEven = parts[2] || "";
  const consecutive = parts[3] || "";

  return { winner, suits, oddEven, consecutive };
};

const Teen = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
  const cards = detailResult?.card ? parseCards(detailResult.card) : { playerA: [], playerB: [] };
  const rdescData = detailResult?.rdesc ? parseRdesc(detailResult.rdesc) : {};
  const winner = detailResult?.winnat || "";
  
  const winValue = detailResult?.win;
  const isPlayerAWinner = winValue === "1" || winner === "Player A";
  const isPlayerBWinner = winValue === "2" || winner === "Player B";

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <h6 className="text-right">
            <b>Round Id :</b> {roundId}
          </h6>
        </div>
      </div>

      <div className="row bottom-border-casino m-t-10">
        <div style={{ width: '100%' }}>
          <div className="player-image-container row">
            <div style={{ flex: '1' }} className="text-center player-number">
              <h4>Player A</h4>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '2px' }}>
                {cards.playerA?.map((card, index) => (
                  card && (
                    <img
                      key={index}
                      src={card}
                      alt={`Player A Card ${index + 1}`}
                      onError={(e) => {
                        const cardName = card.split('/').pop();
                        const fallbackPath = `/assets/img/card-results/${cardName}`;
                        if (e.target.src !== fallbackPath) {
                          e.target.src = fallbackPath;
                        } else {
                          e.target.style.display = 'none';
                        }
                      }}
                    />
                  )
                ))}
              </div>
              <div className="col-md-12 text-center">
                {isPlayerAWinner ? (
                  <label className="winner-label bg-success m-t-20">
                    <i className="fas fa-trophy m-r-5"></i>Winner
                  </label>
                ) : (
                  <label className="m-t-20">&nbsp;</label>
                )}
              </div>
            </div>

            <div style={{ flex: '1' }} className="text-center player-number">
              <h4>Player B</h4>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '2px' }}>
                {cards.playerB?.map((card, index) => (
                  card && (
                    <img
                      key={index}
                      src={card}
                      alt={`Player B Card ${index + 1}`}
                      onError={(e) => {
                        const cardName = card.split('/').pop();
                        const fallbackPath = `/assets/img/card-results/${cardName}`;
                        if (e.target.src !== fallbackPath) {
                          e.target.src = fallbackPath;
                        } else {
                          e.target.style.display = 'none';
                        }
                      }}
                    />
                  )
                ))}
              </div>
              <div className="col-md-12 text-center">
                {isPlayerBWinner ? (
                  <label className="winner-label bg-success m-t-20">
                    <i className="fas fa-trophy m-r-5"></i>Winner
                  </label>
                ) : (
                  <label className="m-t-20">&nbsp;</label>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
{/* 
      {rdescData && (rdescData.oddEven || rdescData.consecutive) && (
        <div className="row mt-3">
          <div className="col-md-12 text-left">
            {rdescData.oddEven && (
              <p className="m-b-0">
                <b>Odd/Even:</b> {rdescData.oddEven}
              </p>
            )}
            {rdescData.consecutive && (
              <p className="m-b-0">
                <b>Consecutive:</b> {rdescData.consecutive}
              </p>
            )}
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Teen;

